import { axiosInstance, axiosInstanceSeguros } from "../helpers/axios";

const userAgent = window.navigator.userAgent;

// El header Authorization se agrega automáticamente mediante el interceptor de axios

const createInsurance = (request, securitykey) => {
  return axiosInstanceSeguros
    .post("createInsuranceRequest/", request)
    .then((res) => {
      const data = res.data;
      return data;
    })
    .catch((err) => {
      return err.response.status;
    });
};

const updateInsurance = (request, securitykey) => {
  return axiosInstanceSeguros
    .post("updateInsuranceRequest/", request)
    .then((res) => {
      const data = res.data;
      return data;
    })
    .catch((err) => {
      return err.response.status;
    });
};

const listInsurance = (request, securitykey) => {
  return axiosInstanceSeguros
    .post("listInsuranceRequest/", request)
    .then((res) => {
      const data = res.data;
      return data;
    })
    .catch((err) => {
      return err.response.status;
    });
};

const uploadDocument = (usuario, securitykey, request) => {
  return axiosInstanceSeguros
    .post("uploadDocument/", request)
    .then((res) => {
      const data = res.data;
      return data;
    })
    .catch((err) => {
      return err.response.status;
    });
};

const getInsurance = (usuario, securitykey, request) => {
  return axiosInstanceSeguros
    .post("getInsuranceRequest/", request)
    .then((res) => {
      const data = res.data;
      return data;
    })
    .catch((err) => {
      return err.response.status;
    });
};

const createInsuranceDocument = (usuario, securitykey, request) => {
  return axiosInstanceSeguros
    .post("createInsuranceDocument/", request)
    .then((res) => {
      const data = res.data;
      return data;
    })
    .catch((err) => {
      return err.response.status;
    });
};

export default {
  createInsurance,
  updateInsurance,
  listInsurance,
  uploadDocument,
  getInsurance,
  createInsuranceDocument,
};
